var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.245.6c.624 0 1.128.216 1.512.648.432.384.648.888.648 1.512 0 .576-.216 1.08-.648 1.512-.384.384-.888.576-1.512.576H5.27V22.92h20.736c.624 0 1.128.192 1.512.576.432.384.648.888.648 1.512s-.216 1.128-.648 1.512c-.384.384-.888.576-1.512.576H5.27V48.84c0 .624-.216 1.152-.648 1.584-.384.384-.888.576-1.512.576-.672 0-1.224-.192-1.656-.576-.384-.432-.576-.96-.576-1.584V2.76c0-.624.192-1.128.576-1.512C1.885.816 2.413.6 3.037.6h26.208z",
    fill: "currentColor"
  })));
}
export default SvgF;